exports = module.exports = require("../../../../../landing-page/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".no-data-notice {\n  text-align: center;\n  margin: 36px 0;\n  color: #B2C4CB;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/css-loader!/Users/alextaxiera/source/farmhand-server/client/landing-page/~/postcss-loader/lib?{"plugins":[null]}!/Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/no-data-message/index.css
// module id = ../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js?{"plugins":[null]}!../../../dashboard/src/js/components/no-data-message/index.css
// module chunks = 0